module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/projects-mca.json
// module id = 324
// module chunks = 265619759847673